import script from "./AchivmentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AchivmentModal.vue?vue&type=script&setup=true&lang=ts"

import "./AchivmentModal.vue?vue&type=style&index=0&id=61315b6c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61315b6c"]])

export default __exports__